import {actionTypes} from '@/core/constants'

export default {
    methods: {

        parametrosPadrao() {
            return {
                corPrimaria: '#4F7E9A',
                corSecundaria: '#487b9c',
                corTerciaria: '#C7D59F'
            }
        },

        async configurarParametros() {
            await this.$store.dispatch(actionTypes.PARAMETROS.BUSCAR_PARAMETROS_CONFIGURACAO)
            if (this.$store.state.configuracao.parametros) {
                this.$vuetify.theme.themes.light.primary = this.$store.state.configuracao.parametros.corPrimaria
                this.$vuetify.theme.themes.light.secondary = this.$store.state.configuracao.parametros.corSecundaria
                this.$vuetify.theme.themes.light.tertiary = this.$store.state.configuracao.parametros.corTerciaria
            } else {
                this.$vuetify.theme.themes.light.primary = this.parametrosPadrao().corPrimaria
                this.$vuetify.theme.themes.light.secondary = this.parametrosPadrao().corSecundaria
                this.$vuetify.theme.themes.light.tertiary = this.parametrosPadrao().corTerciaria
            }
        },

    }
}
